<div class="video-container w-100 h-100">
  <div class="card w-100 h-100">
    <!-- اطلاعات خودرو -->
    <div *ngIf="!isHideInfo" class="card-header pointer">
      <strong *ngIf="obj_Cam?.fullName" (click)="openLink()">
        <small style="color:#1f2937"> {{ obj_Cam.fullName | faNum}} - {{obj_Cam.channel}}</small>
      </strong>
    </div>
    <!-- ویدیو -->
    <div class="card-body p-0 w-100 h-100" [style.max-height]="maxHeight" style="overflow:hidden">
      <!-- گرفتن عکس -->
      <div *ngIf="(tripId && tripId > 0) && ScreenShot" class="position-absolute">
        <button class="btn btn-sm btn-primary pointer" (click)="takeScreenshot()">
          <i class="fa fa-camera" aria-hidden="true"></i>
          گرفتن عکس
        </button>
      </div>
      <video #video controls playsinline webkit-playsinline muted style="width:100%; height:100%; object-fit:contain">
      </video>

    </div>
    <!-- اطلاعات خودرو -->
    <ng-container *ngIf="!isHideInfo">

      <div class="card-footer">

        <div class="row gx-1 gy-0 justify-content-start flex-nowrap overflow-auto">

          <div class="col-auto">
            <button class="btn btn-sm btn-primary w-100 text-center" title="ظبط صدا" (click)="openVoiceRecordModal()">
              <i class="fa fa-volume-up" aria-hidden="true"></i>
            </button>
          </div>

          <div class="col-auto" style="margin-left: auto;">
            <button class="btn btn-sm btn-secondary w-100 text-center" title="اشتراک فیلم" (click)="liveShare()">
              <i class="fa fa-share-alt" aria-hidden="true"></i>
            </button>
          </div>

          <div *ngIf="obj_Cam?.clients" class="col-auto">
            <button class="btn btn-sm btn-outline-secondary w-100 text-center pointer-none">
              <i class="fa fa-eye" aria-hidden="true"></i>
              <small class="mx-1">{{obj_Cam?.clients.toLocaleString() | faNum}}</small>
            </button>
          </div>

          <div *ngIf="obj_Cam?.liveTime" class="col-auto">
            <button class="btn btn-sm btn-outline-secondary w-100 text-center pointer-none">
              <i class="fa fa-clock-o" aria-hidden="true"></i>
              <small class="mx-1">{{obj_Cam?.liveTime | faNum}}</small>
            </button>
          </div>

        </div>

      </div>

    </ng-container>
  </div>

  <!-- مدال اشتراک فیلم -->
  <div class="modal fade" [id]="obj_Cam.strUnitId+'-modal'" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-1">
        <div class="modal-header dirI">
          <h5 class="modal-title"> اشتراک گذاری فیلم </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div [formGroup]="mdlTempAccess" class="row gx-3 gy-4 p-2 mb-2 justify-content-between rounded">
            <div class="position-relative col-md-6 col-12">
              <label for="strFamily" class="text-danger">تاریخ شروع</label>
              <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">
                <input dir="ltr" type="text" formControlName="strSDate" class="form-control">
              </ng-persian-datepicker>
            </div>
            <div class="position-relative col-md-6 col-12">
              <label for="strFamily" class="text-danger">ساعت شروع</label>
              <div class="input-group clockpicker">

                <input type="text" class="form-control text-center" id="Stime" formControlName="strSTime">

                <span class="input-group-addon ">

                  <span class="glyphicon glyphicon-time"></span>

                </span>

              </div>

            </div>

            <div class="position-relative col-md-6 col-12">

              <label for="strFamily" class="text-danger">تاریخ پایان</label>

              <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">

                <input dir="ltr" type="text" formControlName="strEDate" class="form-control">

              </ng-persian-datepicker>

            </div>

            <div class="position-relative col-md-6 col-12">

              <label for="strFamily" class="text-danger">ساعت پایان</label>

              <div class="input-group clockpicker">

                <input type="text" class="form-control text-center" id="Etime" formControlName="strETime">

                <span class="input-group-addon ">

                  <span class="glyphicon glyphicon-time"></span>

                </span>

              </div>

            </div>

            <div class="position-relative col-md-6 col-12">

              <label for="strFamily" class="text-danger">موبایل (کاربری)</label>

              <input dir="ltr" type="text" maxlength="11" formControlName="strMobile" class="form-control">

            </div>

            <div class="position-relative col-md-6 col-12">

              <label for="strFamily" class="text-danger">رمز عبور</label>

              <input dir="ltr" type="text" formControlName="strPassword" class="form-control">

            </div>

          </div>

        </div>

        <div class="modal-footer">
          <div class="col-12 d-flex justify-content-start">
            <button class="btn btn-sm px-4" [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' "
              (click)="new_TempAccess()">
              {{bEditMode ? 'ویرایش' : 'ذخیره' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- مدال ضبط صدا -->
  <voice-record-modal #voiceRecordModal [modalId]="obj_Cam?.strUnitId + '-voice-record-modal'" [strUnitId]="obj_Cam?.strUnitId"></voice-record-modal>

</div>